/* eslint-disable max-len */
import PropTypes from 'prop-types'

import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { fuelTypePropType } from './fuel-type-prop-type'

/**
 * {Object} Idling
 *
 * @property {number}               carbonFootprint     - The carbon footprint (in grams).
 * @property {Id}                   driverId            - The ID of the driver (if available).
 * @property {ISO8601}              endTime             - The end date of the idling (ISO8601).
 * @property {number}               fuelConsumption     - The fuel consumption during idling (in milliliters).
 * @property {FuelTypes}            fuelType            - Fuel type of the vehicle.
 * @property {Id}                   idlingId            - The ID of the idling event.
 * @property {LocationDescription}  locationDescription - The location description of the idling (new TT Reverse Geocoder).
 * @property {Id}                   objectId            - The ID of the object.
 * @property {Position}             position            - The geo position of the idling (decimal degree).
 * @property {Id}                   positionAddressId   - The ID of the address of the idling.
 * @property {ISO8601}              startTime           - The start date of the idling (ISO8601).
 */

export const idlingPropType = PropTypes.shape({
    carbonFootprint: PropTypes.number,
    driverId: idPropType,
    endTime: iso8601PropType,
    fuelConsumption: PropTypes.number,
    fuelType: fuelTypePropType,
    idlingId: idPropType,
    locationDescription: locationDescriptionPropType,
    objectId: idPropType,
    position: positionPropType,
    positionAddressId: idPropType,
    startTime: iso8601PropType
})
